import "./Contact.css";
import { MdEmail } from "react-icons/md";
import { FaPhone } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import { IoIosSend } from "react-icons/io";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { IoLocation } from "react-icons/io5";
import L from "leaflet";
import mapIcon from "./../../assets/map-icon.png";
import "leaflet/dist/leaflet.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert } from "@mui/material";
import SlideIn from "../../animations/components/SlideIn/SlideIn";
import FadeIn from "../../animations/components/FadeIn/FadeIn";
import ResponsiveContainer from "../../responsive/components/ResponsiveContainer/ResponsiveContainer";

const position = [36.76965491661409, 3.059398104694674];

const locationName = "Rue d'Angkor, Alger Centre, Algiers, Algeria";

const customIcon = L.icon({
    iconUrl: mapIcon,
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32]
});


export default function ContactUs() {
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const contactInfo = [
        {
            type: "Email",
            value: "contact@htt.com",
            icon: <MdEmail />
        },
        {
            type: "Phone",
            value: "+213 XXX-XXX-XXXX",
            icon: <FaPhone />
        },
        {
            type: "Address",
            value: locationName,
            icon: <FaLocationDot />
        }
    ]

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: ""
    });

    const handleChange = (e) => {
        setFormData((prevData) => ({
            ...prevData,
            [e.target.name]: e.target.value
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.name || !formData.email || !formData.message) {
            setError("Please fill in all fields.");
            return;
        }
        setSuccess("The form has been submitted successfully!");
        await new Promise((resolve) => setTimeout(resolve, 2000));
        navigate("/thank-you");
        setError(null);
        setSuccess(null);
        setFormData({
            name: "",
            email: "",
            message: ""
        });
    }

    return (
        <section className="contact-page">
            <ResponsiveContainer>
                <h1 className="contact-title ">Contact Us</h1>
            </ResponsiveContainer>

            <ResponsiveContainer>
                <div className="contact-content ">
                    {/* Contact Information */}
                    <SlideIn className="contact-info-section" direction="left" delay={0.4} >
                        <h2>Contact Information</h2>
                        <div className="contact-info-list">
                            {contactInfo.map((info, index) => (
                                <div className="contact-item" key={index}>
                                    <span className="contact-icon" aria-hidden="true">
                                        {info.icon}
                                    </span>
                                    <p className="contact-info">
                                        <strong>{info.label}</strong> {info.value}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </SlideIn>

                    {/* Contact Form */}
                    <SlideIn className="contact-form-section" direction="right" delay={0.4} >
                        <h2>Get in Touch</h2>
                        {
                            error &&
                            <Alert variant="filled" severity="error">
                                {error}
                            </Alert>
                        }
                        {
                            success &&
                            <Alert severity="success">{success}</Alert>
                        }
                        <form className="contact-form" aria-label="Contact Form" onSubmit={handleSubmit}>
                            <label htmlFor="name" className="sr-only" >
                                Your Name
                            </label>
                            <input id="name" type="text" placeholder="Your Name" name="name" onChange={handleChange} />

                            <label htmlFor="email" className="sr-only">
                                Your Email
                            </label>
                            <input id="email" type="email" placeholder="Your Email" name="email" onChange={handleChange} />

                            <label htmlFor="message" className="sr-only">
                                Your Message
                            </label>
                            <textarea
                                id="message"
                                placeholder="Your Message"
                                rows="5"
                                name="message"
                                onChange={handleChange}
                            ></textarea>

                            <button type="submit" className="btn-icon-primary" disabled={success ? true : false}>
                                Send Message <IoIosSend aria-hidden="true" />
                            </button>
                        </form>
                    </SlideIn>
                </div>
            </ResponsiveContainer>

            {/* Embedded Map */}
            <FadeIn delay={0.4} >
                <section className="contact-map">
                    <ResponsiveContainer>

                        <h2>Our Location</h2>
                        <div className="location-container">
                            <div className="map-container" role="region" aria-label="Office Location Map">
                                <MapContainer
                                    center={position}
                                    zoom={15}
                                    style={{ width: "100%", height: "100%", borderRadius: "15px" }}
                                >
                                    <TileLayer
                                        attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    <Marker position={position} icon={customIcon}>
                                        <Popup>
                                            📍 Our Office Location <br /> Algiers, Algeria
                                        </Popup>
                                    </Marker>
                                </MapContainer>
                            </div>

                            <div className="location-info">
                                <h3>Visit Us</h3>
                                <div className="location-item">
                                    <FaLocationDot className="icon" aria-hidden="true" />
                                    <p>{locationName}</p>
                                </div>
                            </div>
                        </div>
                    </ResponsiveContainer>
                </section>
            </FadeIn>
        </section >

    );
}
